<template>
  <div>
    <div class="container">
      <h1 class="title">Startseite bearbeiten</h1>
      <h2 class="subtitle">
        Inhalte verwalten
      </h2>

      <ValidationObserver v-slot="{invalid}" tag="div">
        <div
          class="u-mb2"
          v-bind:class="{'outside-viewport': !buttonsInViewport}"
          v-observe-visibility="{
            callback: visibilityChanged,
            intersection: {
              rootMargin: '100px',
            },
          }"
        >
          <div class="buttons buttongroup--main">
            <b-button @click="addElement()" type="is-dark" icon-left="plus"
              >Neu</b-button
            >
            <b-button :disabled="invalid" @click="save" type="is-success"
              >Startseite speichern</b-button
            >
          </div>
        </div>

        <draggable v-model="home.entries" handle=".handle">
          <transition-group>
            <!-- <div
              class="box box--homepage"
              :id="'homepage' + index"
              v-for="(item, index) in home.entries"
              :key="index"
            > -->
            <!-- <div class="box__actionbuttons">
                <b-button
                  @click="move(home.entries, 'up', index)"
                  icon-left="chevron-up"
                  size="is-medium"
                  type="is-dark"
                  class="box__actionbutton"
                >
                </b-button>
                <b-button
                  @click="move(home.entries, 'down', index)"
                  icon-left="chevron-down"
                  size="is-medium"
                  type="is-dark"
                  class="box__actionbutton"
                ></b-button>
              </div> -->

            <b-collapse
              class="card u-mb1"
              animation="slide-fade"
              aria-id="contentIdForA11y3"
              :open="false"
              :id="'homepage' + index"
              v-for="(item, index) in home.entries"
              :key="index + 0"
            >
              <div
                slot="trigger"
                slot-scope="props"
                class="card-header handle"
                role="button"
                aria-controls="contentIdForA11y3"
              >
                <div class="card-header-title">
                  <p>
                    #{{ index }} {{ item.title }} <br />
                    <small class="has-text-grey-dark has-text-weight-normal"
                      >({{ item.description }})</small
                    >
                  </p>
                </div>
                <a class="card-header-icon">
                  <b-icon :icon="props.open ? 'chevron-up' : 'chevron-down'">
                  </b-icon>
                </a>
              </div>
              <div class="card-content">
                <div class="columns">
                  <div class="column">
                    <ValidationProvider rules="required" v-slot="{errors}">
                      <b-field label="Sprache" :message="errors">
                        <b-select
                          placeholder="Sprache"
                          v-model="item.locale"
                          required
                          expanded
                        >
                          <option value="de">Deutsch</option>
                          <option value="en">Englisch</option>
                          <option value="it">Italienisch</option>
                        </b-select>
                      </b-field>
                    </ValidationProvider>
                  </div>
                  <div class="column">
                    <ValidationProvider rules="required" v-slot="{errors}">
                      <b-field label="Element" :message="errors">
                        <b-select v-model="item.name" expanded>
                          <option
                            v-for="(option, index) in values"
                            :key="index"
                            :value="option.name"
                          >
                            {{ option.display }}
                          </option>
                        </b-select>
                      </b-field>
                    </ValidationProvider>
                  </div>
                  <div class="column">
                    <div v-if="item.name">
                      <ValidationProvider rules="required" v-slot="{errors}">
                        <b-field label="Art" :message="errors">
                          <b-select v-model="item.value" expanded>
                            <option
                              v-for="(option, index) in getValues(item.name)"
                              :value="option.value"
                              :key="index"
                            >
                              {{ option.display }}
                            </option>
                          </b-select>
                        </b-field>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <ValidationProvider rules="required" v-slot="{errors}">
                      <b-field label="Titel" :message="errors">
                        <b-input v-model="item.title" required></b-input>
                      </b-field>
                    </ValidationProvider>
                  </div>
                  <div class="column">
                    <ValidationProvider rules="required" v-slot="{errors}">
                      <b-field label="Beschreibung" :message="errors">
                        <b-input v-model="item.description" required></b-input>
                      </b-field>
                    </ValidationProvider>
                  </div>
                </div>
                <b-button
                  @click="remove(index)"
                  icon-left="trash"
                  size="is-small"
                  type="is-danger"
                  >Entfernen</b-button
                >
              </div>
            </b-collapse>
            <!-- </div> -->
          </transition-group>
        </draggable>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import cmsApi from '@/api/cms-api'
import {mapGetters} from 'vuex'
export default {
  name: 'HomePage',
  components: {
    draggable,
  },
  computed: {
    ...mapGetters({
      userName: 'userName',
    }),
  },
  data() {
    return {
      home: {
        entries: [],
      },
      values: [],
      buttonsInViewport: true,
      isOpen: 0,
    }
  },
  methods: {
    move(a, direction, index) {
      if (a.length > 1) {
        if (direction == 'up') {
          if (index > 0) {
            let tmp = a.splice(index, 1)
            a.splice(index - 1, 0, tmp[0])
          }

          if (index > 1) {
            this.$scrollTo(`#homepage${index - 2}`)
          } else {
            this.$scrollTo('#app')
          }
        } else {
          if (index < a.length - 1) {
            let tmp = a.splice(index, 1)
            a.splice(index + 1, 0, tmp[0])
          }
          this.$scrollTo(`#homepage${index}`)
        }
      }
    },
    async save() {
      try {
        await cmsApi.saveHome(this.home.entries)
        this.$buefy.toast.open({
          message: `Erfolgreich gespeichert.`,
          type: 'is-success',
        })
      } catch {
        this.$buefy.toast.open({
          message: `Es ist ein Fehler aufgetreten, bitte prüfen Sie Ihre Eingaben und versuchen es erneut.`,
          type: 'is-danger',
        })
      }
    },
    addElement() {
      this.home.entries.push({
        name: '',
        value: 'Wert',
        title: 'Titel',
        description: 'Beschreibung',
        locale: 'de',
      })

      this.$scrollTo(`#homepage${this.home.entries.length - 2}`)
    },
    remove(index) {
      this.home.entries.splice(index, 1)
    },
    getValues(name) {
      let res = this.values.find(f => f.name == name)
      if (res && res.values) {
        return res.values
      }
      return []
    },
    visibilityChanged(isVisible) {
      this.buttonsInViewport = isVisible
    },
  },
  async mounted() {
    this.values.push({
      display: 'Kategorie',
      name: 'category',
      values: [
        {display: 'Familie', value: '1'},
        {display: 'Städtereisen', value: '2'},
        {display: 'Romantik', value: '3'},
        {display: 'Ostern', value: '4'},
        {display: 'Wellness', value: '5'},
        {display: 'Rad & Mountainbike', value: '6'},
        {display: 'Skifahren', value: '7'},
        {display: 'Urlaub am Meer', value: '8'},
        {display: 'Business', value: '10'},
        {display: 'Fun', value: '11'},
        {display: 'Golf', value: '12'},
        {display: 'Special', value: '13'},
        {display: 'Wandern', value: '14'},
        {display: 'Gourmet', value: '15'},
        {display: 'Kultur', value: '16'},
        {display: 'Casino', value: '17'},
        {display: 'Shopping', value: '18'},
        {display: 'Ruhe & Erholung', value: '19'},
        {display: 'Last-Minute', value: '20'},
        {display: 'Urlaub am See', value: '21'},
        {display: 'Action & Spaß', value: '22'},
        {display: 'Single', value: '23'},
        {display: 'Gesundheit', value: '24'},
        {display: 'Advent', value: '25'},
        {display: 'Silvester', value: '26'},
        {display: 'Semesterferien', value: '27'},
        {display: 'Luxusurlaub', value: '28'},
        {display: 'Versteigerer', value: '29'},
        {display: 'Events', value: '30'},
        {display: 'Sonnenskilauf', value: '31'},
        {display: 'Schlosshotel', value: '34'},
        {display: 'Weihnacht', value: '35'},
        {display: 'Topseller', value: '36'},
        {display: 'Nur Erwachsene', value: '37'},
        {display: 'Luxusurlaub', value: '38'},
      ],
    })
    this.values.push({
      display: 'Land',
      name: 'country',
      values: [
        {
          display: 'Österreich',
          value: 'AT',
        },
        {
          display: 'Deutschland',
          value: 'DE',
        },
        {
          display: 'Italien',
          value: 'IT',
        },
      ],
    })
    this.values.push({
      display: 'Promotion',
      name: 'promotion',
      values: [
        {
          display: 'Travel Deals',
          value: 'traveldeal',
        },
      ],
    })
    this.home.entries = await cmsApi.getHome()
  },
}
</script>

<style lang="scss">
.box--homepage {
  position: relative;
  margin-bottom: 3rem !important;
}
.box__actionbuttons {
  position: absolute;
  right: 0;
  top: -1rem;
}
.box__actionbutton {
  margin-right: 0.5rem;
}

.outside-viewport {
  .buttongroup--main {
    position: fixed;
    bottom: 0;
    z-index: 1;
    background: #fff;
    padding: 1rem;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
  }
}

// @media (min-width: 1216px) {
//   .box__actionbuttons {
//     right: -4rem;
//     top: auto;
//     width: 3rem;
//     height: 100%;
//   }

//   .box__actionbutton {
//     margin-bottom: 0.5rem;
//   }
// }

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
